// Same paths as the live customer portal
const accessCustomer = {

    PURCHASE_LIST: { name: 'Purchase', path: '/purchase' },

    SESSION_LIST: { name: 'Sessions', path: '/sessions' },

    TICKET_LIST: { name: 'Ticket', path: '/cases' },
    ADD_TICKET: { name: 'Create Ticket', path: '/cases/add-case' },
    TICKET_DETAILS: { name: 'Ticket Details', path: '/cases/remarks-history' },

    RECHARGE: { name: 'Recharge', path: '/recharge' },
    PURCHASE_HISTORY: { name: 'Plan Purchase History', path: '/purchase-history' },
    // payment gateway flow (same paths as the portal)
    PAYMENT_REDIRECT: { name: 'Redirect To Payment', path: '/redirecttopayment' },
    PAYMENT_STATUS: { name: 'Payment Status', path: '/recharge/payment-status' },

    MODEM_PASSWORD: { name: 'Modem Password', path: '/modem-password' },
    SELFCARE_PASSWORD: { name: 'Self Care Password', path: '/selfcare-password' },

}

export default accessCustomer;
